import { useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';

const GET_PUBLISHED_WEBHOOK_API_VERSIONS = graphql(`
  query GetPublishedWebhookApiVersions {
    publishedWebhookApiVersions
  }
`);

const useGetPublishedWebhookApiVersions = () => {
  const { data, ...rest } = useQuery({
    staleTime: minutesToMilliseconds(30),
    queryKey: ['publishedWebhookApiVersions'],
    queryFn: () => gqlClient.request(GET_PUBLISHED_WEBHOOK_API_VERSIONS),
  });

  return { data: data?.publishedWebhookApiVersions, ...rest };
};

export default useGetPublishedWebhookApiVersions;
